import styled from "styled-components/macro";

import { useFnrSelectList3 } from "../FnrSelectList3Context";
import SelectListButton from "../SelectListButton";

import RightDownArrow from "./RightDownArrow";

export default function SelectionWithRightDownArrow({
  title,
  style,
  placeholder,
}) {
  const {
    state: { selection, placeholder: slPlaceholder, options },
    isSimpleList,
  } = useFnrSelectList3();

  const selectedName = () => {
    if (!selection) return placeholder || slPlaceholder;
    if (isSimpleList()) return selection;
    return selection.name || "";
  };

  const displayTitle = () => {
    if (title) return title;
    return selectedName();
  };

  return (
    <>
      <SelectListButton style={style}>
        <Selection disabled={options?.disabled}>
          <span>{displayTitle()}</span>
          <RightDownArrow />
        </Selection>
      </SelectListButton>
    </>
  );
}

const Selection = styled.div`
  font-weight: 400;
  cursor: pointer;
  width: fit-content;
  display: flex;

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.6;
    cursor: not-allowed;
  `}
`;
